import React, { useEffect, useState } from 'react'
import './UserPanelSidebar.css'
import userDefault from '../../Assets/images/userDefault.jpg'
import { RxDashboard } from 'react-icons/rx'
import { LuShoppingCart } from 'react-icons/lu'
import { BsMenuButtonWide } from 'react-icons/bs'
import { AiOutlineLogout } from 'react-icons/ai'
import { HiOutlineBookmark } from 'react-icons/hi'
import { BiEdit } from 'react-icons/bi'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'

export default function UserPanelSidebar({ user }) {
  const navigate = useNavigate();
  const logOut = () => {
    Swal.fire({
      icon: 'error',
      text: 'از حساب کاربری خارج شوید؟',
      confirmButtonText: "بله",
      showCancelButton: true,
      cancelButtonText:
        'خیر',
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("token");
        navigate('/')
      }
    })
  }
  return (
    <>
      <div className='user-panel-sidebar'>
        <div className='user-panel-profile'>
          {
            user.profileImage != null ? (
              <img src={axiosConfig.defaults.baseURL + "Images/UserImage/" + user.id + "/" + user.profileImage} alt="" />
            ) : (
              <img src={userDefault} alt="" />
            )
          }
          {user.username}
        </div>
        <ul>
          <li>
            <NavLink to='/userpanel/'>
              <RxDashboard />
              <h3>پیشخوان</h3>
            </NavLink>
          </li>
          <li>
            <NavLink to='/userpanel/order'>
              <LuShoppingCart />
              <h3> سفارش ها</h3>
            </NavLink>
          </li>
          <li>
            <NavLink to='/userpanel/mycourses'>
              <BsMenuButtonWide />
              <h3> دوره های من</h3>
            </NavLink>
          </li>
          <li>
            <NavLink to='/userpanel/saveItems'>
              <HiOutlineBookmark />
              <h3> موارد سیو شده</h3>
            </NavLink>
          </li>
          <li>
            <NavLink to='/userpanel/editInfo'>
              <BiEdit />
              <h3>ویرایش اطلاعات کاربری</h3>
            </NavLink>
          </li>
          <li onClick={logOut}>
            <Link >
              <AiOutlineLogout />
              <h3> خروج</h3>
            </Link>
          </li>
        </ul>
      </div>
    </>

  )
}
